// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__kwyQy","file":"styles_file__qztBE"};